export const NO_SPECIAL_CHARS = 'Title, Director, and Status cannot contain special characters'
export const RATING_REQUIRED = 'Rating is required'
export const IMAGE_LINK_REQUIRED = 'Requires an image link'
export const AT_LEAST_ONE_FIELD_REQUIRED = 'At least one field is required to be completed'
export const FIELDS_CANNOT_BE_BLANK = 'All fields are required'
export const INVALID_DROPDOWN_SELECTION = 'Invalid dropdown selection'

//there were compile errors when this file is marked as typescript
//switched back to js for easy fix